import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import _extends from '/app/node_modules/babel-runtime/helpers/extends';
import { responseToState } from '~/mappers';
import { SellersApi, ChannelApi, TeamApi, AffiliationApi } from '~/api';
var moment = require('moment');
export var state = function state() {
	return {
		showToolbarBackButton: false,
		toolbarBackUrl: '/',
		toolbarTitle: 'Dashboard',
		day: null,
		process: false,
		worked: false,
		ranking: false,
		filterLayout: false,
		filterComponent: false,
		sellers: [],
		idSeller: null,
		channels: [],
		channelSelected: {},
		idChannel: -1,
		teams: [],
		idTeam: null,
		idSellerByTeam: null,
		titleTableMobile: '',
		affiliation: {
			dateOfClient: {},
			commerceDate: {},
			administrativeAddress: {},
			dataOfAttention: {},
			bankAccounts: {},
			dateProduct: {},
			sellerData: {}
		},
		affiliationDetail: {},
		leaveToDashboard: false
	};
};

export var getters = {
	setLayout: function setLayout(state) {
		return state.filterLayout;
	},
	setComponent: function setComponent(state) {
		return state.filterComponent;
	},

	sellers: function sellers(state) {
		var allSellers = {
			text: 'Todos los vendedores',
			value: -1
		};
		var sellers = state.sellers.slice(0);
		sellers.splice(0, 0, allSellers);
		return sellers;
	},
	titleTableMobile: function titleTableMobile(state, getters, rootState, rootGetters) {
		var titleTableMobile = state.titleTableMobile;

		if (rootState.dashboard.filters.tableNameMobile === 'Process') {
			titleTableMobile = 'Afiliaciones en Proceso';
		} else if (rootState.dashboard.filters.tableNameMobile === 'Work') {
			titleTableMobile = 'Afiliaciones Trabajadas';
		} else {
			titleTableMobile = 'Ranking';
		}
		return titleTableMobile;
	},
	channels: function channels(state) {
		var allChannels = {
			text: 'Todos los canales',
			value: -1
		};
		var channels = state.channels.slice(0);

		channels.splice(0, 0, allChannels);
		return channels;
	}
};

export var mutations = {
	setProcess: function setProcess(state) {
		state.process = !state.process || false;
		state.worked = false;
		state.ranking = false;
	},
	setWorked: function setWorked(state) {
		state.worked = !state.worked || false;
		state.process = false;
		state.ranking = false;
	},
	setRanking: function setRanking(state) {
		state.ranking = !state.ranking || false;
		state.worked = false;
		state.process = false;
	},
	setFilterLayout: function setFilterLayout(state) {
		state.filterLayout = !state.filterLayout || false;
	},
	setFilterComponent: function setFilterComponent(state) {
		state.filterComponent = !state.filterComponent || false;
	},
	setShowToolbarBackButton: function setShowToolbarBackButton(state, showToolbarBackButton) {
		state.showToolbarBackButton = showToolbarBackButton || false;
	},
	setToolbarBackUrl: function setToolbarBackUrl(state, toolbarBackUrl) {
		state.toolbarBackUrl = toolbarBackUrl || '/';
	},
	setToolbarTitle: function setToolbarTitle(state, toolbarTitle) {
		state.toolbarTitle = toolbarTitle;
	},
	setSellers: function setSellers(state, sellers) {
		state.sellers = responseToState(sellers, 'idUser', 'fullName');
	},
	setIdSeller: function setIdSeller(state, val) {
		state.idSeller = val;
	},
	setChannels: function setChannels(state, data) {
		state.channels = data;
		state.channelSelected = data[0];
	},
	setIdChannel: function setIdChannel(state, id) {
		state.idChannel = id;
	},
	setTeam: function setTeam(state, teams) {
		state.teams = teams;
	},
	setIdTeam: function setIdTeam(state, val) {
		state.idTeam = val;
	},
	setIdSellerByTeam: function setIdSellerByTeam(state, val) {
		state.idSellerByTeam = val;
	},
	setFindAffiliationProcess: function setFindAffiliationProcess(state, data) {
		state.affiliationProcess.data = _extends({}, data);
	},
	setFindAffiliation: function setFindAffiliation(state, data) {
		if (data.length === 0) {
			return;
		} else {
			var formatDate = void 0;
			if (data[0].dateTime) {
				formatDate = data[0].dateTime.split('-');
			}
			var date = formatDate[0];
			var time = formatDate[1];

			var parseDate = moment(date.trim(), 'MM-DD-YYYY').format('DD-MM-YYYY').replace('-', '/').replace('-', '/');

			var parseTime = moment(time.trim(), 'HH:mm').add(-5, 'hours').format('HH:mm');

			var resultDate = parseDate + ' - ' + parseTime;
			// console.log("data[0].dateTime--->",data[0].dateTime)
			// console.log("resultDate--->",resultDate)

			state.affiliationDetail = data[0];
			state.affiliation.dateOfClient = {
				ruc: data[0].ruc,
				businessName: data[0].businessName,
				date: resultDate,
				name: data[0].name,
				paternalName: data[0].lastName,
				maternalName: data[0].firstName,
				document: data[0].documentType + ' - ' + data[0].documentNumber,
				cellPhone: data[0].telephoneNumber,
				secondPhone: data[0].secondTelephoneNumber,
				email: data[0].email
			};
			state.affiliation.commerceDate = {
				businessName: data[0].commercialName,
				commercialBusiness: data[0].commercialTurn,
				email: data[0].commercialemail,
				mccNational: data[0].nationalMCC + (data[0].applyToPartnerPlan ? ' - Plan Socios' : '')
			};
			state.affiliation.administrativeAddress = {
				department: data[0].departament,
				province: data[0].province,
				district: data[0].district,
				typeOfRoad: data[0].viaType,
				nameOfRoad: data[0].viaName,
				no: data[0].nro,
				km: data[0].km,
				block: data[0].apple,
				lote: data[0].lote,
				typeOfInterior: data[0].interiorType,
				interior: data[0].interior,
				reference: data[0].reference,
				cellPhone: data[0].telephoneCell,
				phone: data[0].telephoneFixed
			};

			var conditional = data[0].startTime ? data[0].startTime + ' a ' + data[0].endTime : '';

			state.affiliation.dataOfAttention = {
				days: data[0].allDays,
				rangeOfSchedule: conditional
			};
			state.affiliation.bankAccounts = {
				typeOfCoins: data[0].penDescription,
				bank: data[0].penBank,
				typeOfBankAccount: data[0].penTypeAccount,
				numberAccount: data[0].penAccountNumber
			}, state.affiliation.dateProduct = {
				price: data[0].penRental,
				dues: data[0].dues,
				quantityEquipment: data[0].quantityEquipment,
				installationCost: data[0].installationCost,
				installationCostDolar: data[0].installationCostDolar,
				multicomerce: data[0].multicomerce,
				concreted: data[0].concreted,
				reason: data[0].reason || '',
				id: data[0].productId
			};

			state.affiliation.sellerData = {
				product: data[0].productName,
				seller: data[0].seller,
				team: data[0].team,
				channel: data[0].channel
			};
			state.affiliation.associatedImages = data[0].memberShipURL ? data[0].memberShipURL.split(',') : undefined;
		}
	},
	setLeaveToDashboard: function setLeaveToDashboard(state, data) {
		state.leaveToDashboard = data;
	}
};

export var actions = {
	listSellers: function () {
		var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
			var commit = _ref.commit,
			    rootState = _ref.rootState,
			    state = _ref.state;
			var conditional, seller, sellers, allSellers, sellersTransform;
			return _regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							conditional = void 0;

							rootState.user.roleId === 2 || rootState.user.roleId === 1 ? conditional = state.idTeam || 0 : conditional = rootState.user.idTeam || 0;

							_context.next = 4;
							return new SellersApi(this.$axios).getSellersData({
								idTeam: conditional
							});

						case 4:
							seller = _context.sent;

							commit('setSellers', seller);
							sellers = responseToState(seller, 'idUser', 'fullName');
							allSellers = {
								text: 'Todos los vendedores',
								value: -1
							};
							sellersTransform = sellers.slice(0);

							sellersTransform.splice(0, 0, allSellers);
							return _context.abrupt('return', sellersTransform);

						case 11:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, this);
		}));

		function listSellers(_x) {
			return _ref2.apply(this, arguments);
		}

		return listSellers;
	}(),
	getChannels: function () {
		var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3, idRole) {
			var commit = _ref3.commit,
			    dispatch = _ref3.dispatch,
			    rootState = _ref3.rootState;
			return _regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.t0 = idRole || rootState.user.roleId;
							_context2.next = _context2.t0 === 1 ? 3 : _context2.t0 === 2 ? 5 : 7;
							break;

						case 3:
							dispatch('listChannels');
							return _context2.abrupt('break', 7);

						case 5:
							dispatch('findAllChannelByBoss');
							return _context2.abrupt('break', 7);

						case 7:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		function getChannels(_x2, _x3) {
			return _ref4.apply(this, arguments);
		}

		return getChannels;
	}(),

	//administrador
	listChannels: function () {
		var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5, idRole) {
			var commit = _ref5.commit,
			    rootState = _ref5.rootState,
			    dispatch = _ref5.dispatch;
			var channel, channelResponse;
			return _regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_context3.t0 = idRole || rootState.user.roleId;
							_context3.next = _context3.t0 === 1 ? 3 : _context3.t0 === 2 ? 9 : 12;
							break;

						case 3:
							_context3.next = 5;
							return new ChannelApi(this.$axios).findAllChannel();

						case 5:
							channel = _context3.sent;
							channelResponse = responseToState(channel, 'idChannel', 'name');

							commit('setChannels', channelResponse);
							return _context3.abrupt('break', 12);

						case 9:
							_context3.next = 11;
							return dispatch('findAllChannelByBoss', rootState.user.userId);

						case 11:
							return _context3.abrupt('break', 12);

						case 12:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, this);
		}));

		function listChannels(_x4, _x5) {
			return _ref6.apply(this, arguments);
		}

		return listChannels;
	}(),


	//rol boss
	findAllChannelByBoss: function () {
		var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
			var rootState = _ref7.rootState,
			    commit = _ref7.commit;
			var response, channelByBoss;
			return _regeneratorRuntime.wrap(function _callee4$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							_context4.next = 2;
							return new ChannelApi(this.$axios).findAllChannelByBoss({
								idBoss: rootState.user.userId
							});

						case 2:
							response = _context4.sent;
							channelByBoss = responseToState(response, 'idChannel', 'name');

							commit('setChannels', channelByBoss);

						case 5:
						case 'end':
							return _context4.stop();
					}
				}
			}, _callee4, this);
		}));

		function findAllChannelByBoss(_x6) {
			return _ref8.apply(this, arguments);
		}

		return findAllChannelByBoss;
	}(),
	findTeamByChannel: function () {
		var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9, _ref10) {
			var commit = _ref9.commit,
			    dispatch = _ref9.dispatch,
			    state = _ref9.state;
			var channelId = _ref10.channelId;
			var response, team, teamTransform, allTeams;
			return _regeneratorRuntime.wrap(function _callee5$(_context5) {
				while (1) {
					switch (_context5.prev = _context5.next) {
						case 0:
							_context5.next = 2;
							return new TeamApi(this.$axios).findAllTeamForChannel({
								idChannel: channelId || 0
							});

						case 2:
							response = _context5.sent;
							team = responseToState(response, 'idteam', 'name');

							commit('setTeam', team);

							_context5.next = 7;
							return dispatch('dashboard/table/updateDataByBossAdmin', {
								idChannel: state.idChannel || -1,
								idTeam: -1,
								idSeller: -1
							}, { root: true });

						case 7:
							teamTransform = team.slice(0);
							allTeams = {
								text: 'Todos los equipos',
								value: -1
							};

							teamTransform.splice(0, 0, allTeams);
							return _context5.abrupt('return', teamTransform);

						case 11:
						case 'end':
							return _context5.stop();
					}
				}
			}, _callee5, this);
		}));

		function findTeamByChannel(_x7, _x8) {
			return _ref11.apply(this, arguments);
		}

		return findTeamByChannel;
	}(),


	//detailAffiliationProcess
	findAffiliationProcess: function () {
		var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref12, data) {
			var state = _ref12.state,
			    commit = _ref12.commit;
			var response;
			return _regeneratorRuntime.wrap(function _callee6$(_context6) {
				while (1) {
					switch (_context6.prev = _context6.next) {
						case 0:
							_context6.next = 2;
							return new AffiliationApi(this.$axios).findAffiliationProcess({
								idAffiliationProcess: Number(data.idAffiliationPoW || 0),
								idAffiliation: Number(data.idAffiliation || 0)
							});

						case 2:
							response = _context6.sent;


							commit('setFindAffiliation', response);

						case 4:
						case 'end':
							return _context6.stop();
					}
				}
			}, _callee6, this);
		}));

		function findAffiliationProcess(_x9, _x10) {
			return _ref13.apply(this, arguments);
		}

		return findAffiliationProcess;
	}(),
	findAffiliationWorked: function () {
		var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref14, data) {
			var state = _ref14.state,
			    commit = _ref14.commit;
			var response;
			return _regeneratorRuntime.wrap(function _callee7$(_context7) {
				while (1) {
					switch (_context7.prev = _context7.next) {
						case 0:
							_context7.next = 2;
							return new AffiliationApi(this.$axios).findAffiliationWorked({
								idAffiliationWork: Number(data.idAffiliationPoW || 0),
								idAffiliation: Number(data.idAffiliation || 0)
							});

						case 2:
							response = _context7.sent;

							commit('setFindAffiliation', response);
							//return response

						case 4:
						case 'end':
							return _context7.stop();
					}
				}
			}, _callee7, this);
		}));

		function findAffiliationWorked(_x11, _x12) {
			return _ref15.apply(this, arguments);
		}

		return findAffiliationWorked;
	}(),
	affiliationDetail: function () {
		var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref16, data) {
			var state = _ref16.state,
			    dispatch = _ref16.dispatch;
			return _regeneratorRuntime.wrap(function _callee8$(_context8) {
				while (1) {
					switch (_context8.prev = _context8.next) {
						case 0:
							if (!(data.type === 'process')) {
								_context8.next = 5;
								break;
							}

							_context8.next = 3;
							return dispatch('findAffiliationProcess', data);

						case 3:
							_context8.next = 7;
							break;

						case 5:
							_context8.next = 7;
							return dispatch('findAffiliationWorked', data);

						case 7:
						case 'end':
							return _context8.stop();
					}
				}
			}, _callee8, this);
		}));

		function affiliationDetail(_x13, _x14) {
			return _ref17.apply(this, arguments);
		}

		return affiliationDetail;
	}(),
	downloadAfiliationRequest: function () {
		var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref18) {
			var state = _ref18.state;

			var _state$affiliation, administrativeAddress, bankAccounts, commerceDate, dataOfAttention, dateOfClient, dateProduct, sellerData, affiliation, sameACommercialAddress;

			return _regeneratorRuntime.wrap(function _callee9$(_context9) {
				while (1) {
					switch (_context9.prev = _context9.next) {
						case 0:
							_state$affiliation = state.affiliation, administrativeAddress = _state$affiliation.administrativeAddress, bankAccounts = _state$affiliation.bankAccounts, commerceDate = _state$affiliation.commerceDate, dataOfAttention = _state$affiliation.dataOfAttention, dateOfClient = _state$affiliation.dateOfClient, dateProduct = _state$affiliation.dateProduct, sellerData = _state$affiliation.sellerData;
							affiliation = state.affiliationDetail;
							sameACommercialAddress = true; //De donde sale?

							if (!false) {
								_context9.next = 7;
								break;
							}

							return _context9.abrupt('return', new AffiliationApi(this.$axios).downloadPosAfiliationRequest({
								membershipType: 'IND',
								commerceCode: '', // de donde sale?
								executive: '', // de donde sale?
								commercialName: affiliation.commercialName,
								businessName: affiliation.businessName,
								ruc: affiliation.ruc,
								MCCI: '', // de donde sale?
								MCCN: affiliation.nationalMCC,
								commercialAddress: {
									department: affiliation.departament,
									province: affiliation.province,
									district: affiliation.district,
									cellphoneOne: administrativeAddress.cellPhone,
									cellphoneTwo: administrativeAddress.phone,
									roadType: administrativeAddress.typeOfRoad,
									roadName: administrativeAddress.nameOfRoad,
									number: administrativeAddress.no,
									interiorType: administrativeAddress.typeOfInterior,
									interiorName: administrativeAddress.interior,
									// plusCode: administrativeAddress.plusCode,
									km: administrativeAddress.km,
									block: administrativeAddress.block,
									lot: administrativeAddress.lote,
									reference: administrativeAddress.reference,
									typeUrbanHabilitation: administrativeAddress.typeUrbanHabilitation,
									urbanHabilitation: administrativeAddress.urbanHabilitation,
									schedule: dataOfAttention.rangeOfSchedule
								},
								sameACommercialAddress: false,
								// direccion administrativa
								administrativeAddress: {
									department: sameACommercialAddress ? administrativeAddress.departament : '',
									province: sameACommercialAddress ? administrativeAddress.province : '',
									district: sameACommercialAddress ? administrativeAddress.district : '',
									cellphoneOne: sameACommercialAddress ? administrativeAddress.cellPhone : '',
									cellphoneTwo: sameACommercialAddress ? administrativeAddress.phone : '',
									roadType: sameACommercialAddress ? administrativeAddress.typeOfRoad : '',
									roadName: sameACommercialAddress ? administrativeAddress.nameOfRoad : '',
									number: sameACommercialAddress ? administrativeAddress.no : '',
									interiorType: sameACommercialAddress ? administrativeAddress.typeOfInterior : '',
									interiorName: sameACommercialAddress ? administrativeAddress.interior : '',
									// plusCode: sameACommercialAddress ? administrativeAddress.plusCode : '',
									km: sameACommercialAddress ? administrativeAddress.km : '',
									block: sameACommercialAddress ? administrativeAddress.block : '',
									lot: sameACommercialAddress ? administrativeAddress.lote : '',
									reference: sameACommercialAddress ? administrativeAddress.reference : '',
									typeUrbanHabilitation: sameACommercialAddress ? administrativeAddress.typeUrbanHabilitation : '',
									urbanHabilitation: sameACommercialAddress ? administrativeAddress.urbanHabilitation : '',
									schedule: sameACommercialAddress ? dataOfAttention.rangeOfSchedule : ''
								},
								legalRepresentative: {
									paternalLastname: dateOfClient.paternalName,
									maternalLastname: dateOfClient.maternalName,
									names: dateOfClient.name,
									documentType: dateOfClient.document.split('-')[0],
									documentNumber: dateOfClient.document.split('-')[1],
									phone: dateOfClient.secondPhone,
									cellphone: dateOfClient.cellPhone,
									email: dateOfClient.email
								},
								connectionType: 'RTC', // De dónde sale?
								multicommerce: dateProduct.multicomerce,
								equipmentNumber: dateProduct.dues,
								relatedTariff: {
									// de donde sale?
									creditCommissionNacional: affiliation.penCreditCard,
									creditCommissionInternational: affiliation.usdCreditCard,
									creditDebitNacional: affiliation.penDebitCard,
									creditDebitInternational: affiliation.usdDebitCard,
									equipmentInstalation: '',
									quota: '',
									monthlyRental: '',
									monthlyAccountStatement: ''
								},
								osvType: null,
								paymentData: {
									currencyType: bankAccount.typeOfCoins,
									bankNameSoles: bankAccount.typeOfCoins == 'Soles' ? bankAccount.bank : '',
									accountTypeSoles: bankAccount.typeOfCoins == 'Soles' ? bankAccount.typeOfBankAccount : '',
									accountNumberSoles: bankAccount.typeOfCoins == 'Soles' ? bankAccount.numberAccount : '',
									bankNameDolares: bankAccount.typeOfCoins !== 'Soles' ? bankAccount.bank : '',
									accountTypeDolares: bankAccount.typeOfCoins !== 'Soles' ? bankAccount.typeOfBankAccount : '',
									accountNumberDolares: bankAccount.typeOfCoins !== 'Soles' ? bankAccount.numberAccount : ''
								}
							}));

						case 7:
							return _context9.abrupt('return', new AffiliationApi(this.$axios).downloadCeAfiliationRequest({
								commerceCode: '',
								executive: '',
								commercialName: affiliation.commercialName,
								businessName: affiliation.businessName,
								ruc: affiliation.ruc,
								MCCI: '', // de donde sale?
								MCCN: affiliation.nationalMCC,
								administrativeAddress: '',
								department: affiliation.departament,
								province: affiliation.province,
								district: affiliation.district,
								legalRepresentative: {
									paternalLastname: dateOfClient.paternalName,
									maternalLastname: dateOfClient.maternalName,
									names: dateOfClient.name,
									documentType: affiliation.documentType,
									documentNumber: affiliation.documentNumber,
									phone: dateOfClient.secondPhone,
									cellphone: dateOfClient.cellPhone,
									email: dateOfClient.email
								},
								administratorPMM: {
									fullname: '',
									email: '',
									phone: ''
								},
								paymentData: {
									currencyType: affiliation.penDescription.length ? affiliation.penDescription : affiliation.usdDescription,
									bankName: affiliation.penDescription.length ? affiliation.penBank : affiliation.usdBank,
									accountType: affiliation.penDescription.length ? affiliation.penTypeAccount : affiliation.usdTypeAccount,
									accountNumberSoles: affiliation.penDescription.length ? affiliation.penAccountNumber : affiliation.usdAccountNumber
								},
								transactionData: {
									subProduct: '',
									currency: '',
									creditCommissionNacional: affiliation.penCreditCard,
									creditCommissionInternational: affiliation.usdCreditCard,
									creditDebitNacional: affiliation.penDebitCard,
									creditDebitInternational: affiliation.usdDebitCard,
									integration: '',
									plataformUse: '',
									monthlyMaintenance: '',
									annualRenewal: '',
									monthlyAccountState: ''
								},
								virtualShop: {
									pageURL: '',
									appName: '',
									OS: ''
								},
								developer: {
									delevelopType: '',
									fullname: '',
									company: '',
									phone: '',
									email: ''
								}
							}));

						case 8:
						case 'end':
							return _context9.stop();
					}
				}
			}, _callee9, this);
		}));

		function downloadAfiliationRequest(_x15) {
			return _ref19.apply(this, arguments);
		}

		return downloadAfiliationRequest;
	}()
};


//////////////////
// WEBPACK FOOTER
// ./src/store/dashboard/details.js
// module id = ./src/store/dashboard/details.js
// module chunks = 34